/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingLineItemIdentity {
    getFixupPrototypeFunction() { return BillingLineItemIdentity.fixupPrototype; }

    static newInstance(model: Partial<BillingLineItemIdentity>): BillingLineItemIdentity {
        let obj = Object.assign(new BillingLineItemIdentity(), model);
        BillingLineItemIdentity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingLineItemIdentity>): BillingLineItemIdentity {
        if (!model) return null;
        return BillingLineItemIdentity.newInstance(<BillingLineItemIdentity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingLineItemIdentity) {
        if (!obj) return;

        models.BillingLineItemIdentity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingLineItemIdentity): boolean {
        Object.setPrototypeOf(obj, BillingLineItemIdentity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.extras) {
            for (let val of this.extras) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePairKind.fixupPrototype(val);
            }
        }
        if (this.hierarchy) {
            for (let val of this.hierarchy) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
        if (this.custom) {
            for (let val of this.custom) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
        if (this.dimension_memberships) {
            for (let val of this.dimension_memberships) {
                models.DimensionMembershipKeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account the line item belongs to
     */
    service_account_id: string;

    /**
     * Service Account internally responsible for creating, updating, or deleting the line item
     */
    delegate_service_account_id: string;

    /**
     * Line item type
     */
    line_item_type: string;

    /**
     * Availability Zone
     */
    availability_zone: string;

    /**
     * Billing Entity
     */
    billing_entity: string;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * Line item location
     */
    location: string;

    /**
     * Meter Sub Category
     */
    meter_sub_category: string;

    /**
     * Pricing Category
     */
    pricing_category: string;

    /**
     * Pricing Purchase Option
     */
    pricing_purchase_option: string;

    /**
     * Product category
     */
    product_category: string;

    /**
     * Product family
     */
    product_family: string;

    /**
     * Product service code
     */
    product_service_code: string;

    /**
     * Product SKU
     */
    product_sku: string;

    /**
     * Publisher
     */
    publisher: string;

    /**
     * Resource category
     */
    resource_category: string;

    /**
     * Resource group
     */
    resource_group: string;

    /**
     * Resource ID
     */
    resource_id: string;

    /**
     * Resource name
     */
    resource_name: string;

    /**
     * Resource operation
     */
    resource_operation: string;

    /**
     * Resource type
     */
    resource_type: string;

    /**
     * Utilization type
     */
    utilization_type: string;

    /**
     * List of tag key/value pairs
     */
    extras: Array<models.KeyValuePair>;

    /**
     * List of tag key/value and kind
     */
    tags: Array<models.KeyValuePairKind>;

    /**
     * List of tag key/value pairs
     */
    hierarchy: Array<models.KeyValuePair>;

    /**
     * List of tag key/value pairs
     */
    custom: Array<models.KeyValuePair>;

    /**
     * List of Dimension Membership Key-Value Pairs
     */
    dimension_memberships: Array<models.DimensionMembershipKeyValuePair>;

    /**
     * Compartment ID
     */
    compartment_id: string;

    /**
     * Compartment Name
     */
    compartment_name: string;

    /**
     * Compartment Path
     */
    compartment_path: string;

}
